import type { ListTableRowActionsProviderProps } from "./list-table-row-actions.type";

import { useState } from "react";

import { useAsyncActions } from "@/modules/async-actions";

import ListTableRowActions from "./list-table-row-actions.component";
import { ListTableRowActionsContext } from "./list-table-row-actions.context";

const ListTableRowActionsProvider = ({
  modelKey,
  modelId,
  children,
}: ListTableRowActionsProviderProps) => {
  const [isOpen, setOpen] = useState(false);
  const { isInDeletingState } = useAsyncActions();
  const isDeleting =
    modelKey && modelId && isInDeletingState(modelKey, modelId) ? true : false;

  return (
    <ListTableRowActionsContext.Provider
      value={{
        isOpen,
        setOpen,
        closePopover: () => setOpen(false),
      }}
    >
      <ListTableRowActions isDeleting={isDeleting}>
        {children}
      </ListTableRowActions>
    </ListTableRowActionsContext.Provider>
  );
};

export default ListTableRowActionsProvider;
